import { render } from "./Saved.vue?vue&type=template&id=263f74a2&scoped=true&ts=true"
import script from "./Saved.vue?vue&type=script&lang=ts"
export * from "./Saved.vue?vue&type=script&lang=ts"

import "./Saved.vue?vue&type=style&index=0&id=263f74a2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-263f74a2"]])

export default __exports__